export interface EnneagramQuestion {
  id: number;
  type: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  text: string;
}

export const enneagramQuestions: EnneagramQuestion[] = [
  { id: 1, type: 1, text: '我常常要求自己把事情做到“正确且规范”。' },
  { id: 2, type: 1, text: '看到低标准或不公正时，我会很难忍住不指出。' },
  { id: 3, type: 1, text: '我对“自律”和“责任感”有很高要求。' },
  { id: 4, type: 1, text: '我会因为小失误反复检讨自己。' },

  { id: 5, type: 2, text: '我会优先照顾身边人的需求。' },
  { id: 6, type: 2, text: '被需要会让我感到自己的价值。' },
  { id: 7, type: 2, text: '我不太擅长直接表达“我也需要被照顾”。' },
  { id: 8, type: 2, text: '我容易在关系里承担太多。' },

  { id: 9, type: 3, text: '我会通过成绩、效率或结果来证明自己。' },
  { id: 10, type: 3, text: '我习惯给自己设定明确目标并追求达成。' },
  { id: 11, type: 3, text: '我很在意外界对我能力与形象的评价。' },
  { id: 12, type: 3, text: '停下来时，我会有“落后”的焦虑感。' },

  { id: 13, type: 4, text: '我常觉得自己和别人不太一样。' },
  { id: 14, type: 4, text: '我的情绪体验通常比较深、比较细。' },
  { id: 15, type: 4, text: '我会渴望被真正理解，而不是被“安慰”。' },
  { id: 16, type: 4, text: '我在关系里很在意独特性与真实感。' },

  { id: 17, type: 5, text: '我需要大量独处来恢复与思考。' },
  { id: 18, type: 5, text: '在表达前，我更习惯先把信息想透。' },
  { id: 19, type: 5, text: '我倾向于通过知识与分析获得安全感。' },
  { id: 20, type: 5, text: '当外界要求太多时，我会本能地抽离。' },

  { id: 21, type: 6, text: '我会习惯性评估风险并准备备选方案。' },
  { id: 22, type: 6, text: '不确定情境下，我会先确认规则与边界。' },
  { id: 23, type: 6, text: '我重视可靠关系，担心被辜负或失去支持。' },
  { id: 24, type: 6, text: '我会反复确认决定是否足够稳妥。' },

  { id: 25, type: 7, text: '我倾向于保持积极，不想被负面情绪困住。' },
  { id: 26, type: 7, text: '我喜欢新鲜体验和多种可能性。' },
  { id: 27, type: 7, text: '当压力很大时，我会想“换个有趣方向”。' },
  { id: 28, type: 7, text: '我不太喜欢长期被单一模式束缚。' },

  { id: 29, type: 8, text: '我不喜欢被控制，更倾向自己做主。' },
  { id: 30, type: 8, text: '遇到冲突时我更愿意正面应对。' },
  { id: 31, type: 8, text: '我会保护我在乎的人，不怕承担压力。' },
  { id: 32, type: 8, text: '我看重力量、边界和直接沟通。' },

  { id: 33, type: 9, text: '我倾向于维持和气，避免冲突升级。' },
  { id: 34, type: 9, text: '我会为了大局而压住自己的真实想法。' },
  { id: 35, type: 9, text: '我喜欢稳定、舒缓、可持续的节奏。' },
  { id: 36, type: 9, text: '当环境紧张时，我更想先缓和气氛。' },

  { id: 37, type: 1, text: '我认为秩序和规则是维持社会运转的基础。' },
  { id: 38, type: 1, text: '我很难容忍敷衍了事或得过且过的态度。' },

  { id: 39, type: 2, text: '我常常能敏锐察觉别人未说出口的情感需要。' },
  { id: 40, type: 2, text: '付出和给予能让我感到充实和被认可。' },

  { id: 41, type: 3, text: '我倾向于用成就和头衔来定义自己的价值。' },
  { id: 42, type: 3, text: '失败或落后于同龄人会让我非常不安。' },

  { id: 43, type: 4, text: '我容易被悲伤、遗憾等深层情绪所触动。' },
  { id: 44, type: 4, text: '我渴望在人群中保持独特，不愿泯然众人。' },

  { id: 45, type: 5, text: '我倾向于观察多于参与，先理解再行动。' },
  { id: 46, type: 5, text: '当信息不足时，我会感到不安全感。' },

  { id: 47, type: 6, text: '我会提前设想最坏情况并准备应对。' },
  { id: 48, type: 6, text: '一旦建立信任，我会对关系非常忠诚。' },

  { id: 49, type: 7, text: '我喜欢保持选项开放，不愿过早做出限制性承诺。' },
  { id: 50, type: 7, text: '面对痛苦，我倾向于用转移注意力来应对。' },

  { id: 51, type: 8, text: '我讨厌被人轻视或当成弱者对待。' },
  { id: 52, type: 8, text: '我会直接表达不满，不愿憋在心里。' },

  { id: 53, type: 9, text: '我容易在别人的需求和自己的需求之间迷失。' },
  { id: 54, type: 9, text: '平静、没有冲突的环境能让我更好地发挥。' },
];

export const enneagramTypeDescriptions: Record<number, string> = {
  1: '1号 完美型：原则感强、标准高，追求正确与改进。',
  2: '2号 助人型：重关系与付出，渴望被需要与被爱。',
  3: '3号 成就型：目标导向强，重效率、成果与认可。',
  4: '4号 自我型：情感深、重独特，追求真实与意义。',
  5: '5号 理智型：观察分析强，重边界、知识与独立。',
  6: '6号 忠诚型：谨慎稳健，擅长预案与风险管理。',
  7: '7号 活跃型：乐观灵动，追求体验与自由可能。',
  8: '8号 领袖型：直接果断，重掌控、保护与力量。',
  9: '9号 和平型：温和包容，重稳定、协调与连接。',
};
